import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  DashboardInstallationData,
  ViError,
  ViguideRecommendations,
} from '../../../projects/client';
import {
  IgnoredOptimizationRecommendationTileSettings,
  OptimizationRecommendationSlug,
} from './viguide-recommendations.model';

export namespace ViguideRecommendationActions {
  export enum Type {
    GET_OPTIMIZATION_RECOMMENDATIONS_ATTEMPT = '[VIGUIDE RECOMMENDATIONS] Get optimization recommendations attempt',
    GET_OPTIMIZATION_RECOMMENDATIONS_SUCCESS = '[VIGUIDE RECOMMENDATIONS] Get optimization recommendations success',
    GET_OPTIMIZATION_RECOMMENDATIONS_ERROR = '[VIGUIDE RECOMMENDATIONS] Get optimization recommendations error',
    GET_IGNORED_RECOMMENDATION_TILES_SETTINGS = '[VIGUIDE RECOMMENDATIONS] Get ignored recommendation tiles settings',
    CLOSE_RECOMMENDATION_TILE = '[VIGUIDE RECOMMENDATIONS] Close recommendation tile',
    UPDATE_IGNORED_RECOMMENDATION_TILES_SETTINGS = '[VIGUIDE RECOMMENDATIONS] Update ignored recommendation tiles settings',
  }

  export const getOptimizationRecommendationsAttempt = createAction(
    Type.GET_OPTIMIZATION_RECOMMENDATIONS_ATTEMPT
  );

  export const getOptimizationRecommendationsSuccess = createAction(
    Type.GET_OPTIMIZATION_RECOMMENDATIONS_SUCCESS,
    props<{ optimizationRecommendations: ViguideRecommendations[] }>()
  );

  export const getOptimizationRecommendationsError = createAction(
    Type.GET_OPTIMIZATION_RECOMMENDATIONS_ERROR,
    props<{ error: any }>()
  );

  export const getIgnoredRecommendationTilesSettings = createAction(
    Type.GET_IGNORED_RECOMMENDATION_TILES_SETTINGS
  );

  export const closeRecommendationTile = createAction(
    Type.CLOSE_RECOMMENDATION_TILE,
    props<{ tileName: OptimizationRecommendationSlug }>()
  );

  export const updateIgnoredRecommendationTilesSettings = createAction(
    Type.UPDATE_IGNORED_RECOMMENDATION_TILES_SETTINGS,
    props<{ ignoredTilesSettings: IgnoredOptimizationRecommendationTileSettings }>()
  );

  export const fetchProInstallations = createActionGroup({
    source: 'VIGUIDE RECOMMENDATIONS Fetch pro installations',
    events: {
      attempt: emptyProps(),
      success: props<{ installations: DashboardInstallationData[] }>(),
      error: props<{ error: ViError }>(),
    },
  });
}
